<template>
  <div>
    <b-list-group horizontal>
      <b-list-group-item
        class="col-6 d-flex align-items-center"
        style="
          background-color: rgba(114, 114, 114, 0.05);
          border-style: solid;
          border-width: 1px;
          border-color: rgba(114, 114, 114, 0.15);
        "
      >
        <h6 class="m-0 my-1">Ursachen</h6>
      </b-list-group-item>

      <b-list-group-item class="col-6 d-flex align-items-center py-0 pl-2">
        <AppSelect
          v-model="formVariables.ursacheSelected"
          :options="ursachenOptions"
          text-field="label"
          value-field="enum"
          label="Ursache"
          placeholder="Ursache auswählen"
          clearable
          @change="checkIfDataWasChangedAndCommit"
        />
      </b-list-group-item>
    </b-list-group>
    <b-list-group horizontal>
      <b-list-group-item
        class="col-6 d-flex align-items-center"
        style="
          background-color: rgba(114, 114, 114, 0.05);
          border-style: solid;
          border-width: 1px;
          border-color: rgba(114, 114, 114, 0.15);
        "
      >
        <h6 class="m-0 my-1">Beschreibung</h6>
      </b-list-group-item>
      <b-list-group-item class="col-6 d-flex align-items-center p-0">
        <b-form-input
          v-model="formVariables.beschreibungText"
          @input="checkIfDataWasChangedAndCommit"
          class="border-0"
          style="font-size: 16px"
          placeholder="Beschreibung einfügen..."
        ></b-form-input>
        <i
          v-if="formVariables.beschreibungText"
          class="fas fa-times text-danger ml-auto mr-5"
          @click="resetBeschreibung"
          style="cursor: pointer"
        ></i>
      </b-list-group-item>
    </b-list-group>
    <b-list-group horizontal>
      <b-list-group-item
        class="col-6 d-flex align-items-center"
        style="
          background-color: rgba(114, 114, 114, 0.05);
          border-style: solid;
          border-width: 1px;
          border-color: rgba(114, 114, 114, 0.15);
        "
      >
        <h6 class="m-0 my-1">Bearbeitungsstatus</h6>
      </b-list-group-item>
      <b-list-group-item class="col-6 d-flex align-items-center py-0 pl-2">
        <AppSelect
          v-model="formVariables.statusSelected"
          :options="statusOptions"
          text-field="label"
          value-field="enum"
          label="Status"
          placeholder="Status auswählen"
          hide-search
          clearable
          @change="onStatusChange"
        />
      </b-list-group-item>
    </b-list-group>

    <b-list-group
      horizontal
      v-if="
        (data.bearbeitungStatus === 'VerfuegbarkeitGeschaffen' && formVariables.statusSelected === null) ||
        formVariables.statusSelected === 'VerfuegbarkeitGeschaffen'
      "
    >
      <b-list-group-item
        class="col-6 d-flex align-items-center"
        style="
          background-color: rgba(114, 114, 114, 0.05);
          border-style: solid;
          border-width: 1px;
          border-color: rgba(114, 114, 114, 0.15);
        "
      >
        <h6 class="m-0 my-1">Lösungsansatz</h6>
      </b-list-group-item>
      <b-list-group-item class="col-6 d-flex align-items-center py-0 pl-2">
        <AppSelect
          v-model="formVariables.loesungsansatzSelected"
          :options="loesungsansatzOptions"
          text-field="label"
          value-field="enum"
          label="Lösungsansatz"
          placeholder="Lösungsansatz auswählen"
          hide-search
          clearable
          @change="checkIfDataWasChangedAndCommit"
        />
      </b-list-group-item>
    </b-list-group>

    <b-list-group
      horizontal
      v-if="
        (data.bearbeitungStatus === 'Akzeptiert' && formVariables.statusSelected === null) ||
        formVariables.statusSelected === 'Akzeptiert'
      "
    >
      <b-list-group-item
        class="col-6 d-flex align-items-center"
        style="
          background-color: rgba(114, 114, 114, 0.05);
          border-style: solid;
          border-width: 1px;
          border-color: rgba(114, 114, 114, 0.15);
        "
      >
        <h6 class="m-0 my-1">Akzeptanzgrund</h6>
      </b-list-group-item>
      <b-list-group-item class="col-6 d-flex align-items-center py-0 pl-2">
        <AppSelect
          v-model="formVariables.akzeptanzgrundSelected"
          :options="akzeptanzgrundOptions"
          :state="formVariables.akzeptanzgrundSelected !== null"
          text-field="label"
          value-field="enum"
          label="Akzeptanzgrund"
          placeholder="Akzeptanzgrund auswählen"
          clearable
          @change="checkIfDataWasChangedAndCommit"
        />
      </b-list-group-item>
    </b-list-group>
    <b-list-group horizontal>
      <b-list-group-item
        class="col-6 d-flex align-items-center"
        style="
          background-color: rgba(114, 114, 114, 0.05);
          border-style: solid;
          border-width: 1px;
          border-color: rgba(114, 114, 114, 0.15);
        "
      >
        <h6 class="m-0 my-1">Bearbeitende Person</h6>
      </b-list-group-item>
      <b-list-group-item
        class="col-6 d-flex align-items-center"
        style="
          background-color: rgba(114, 114, 114, 0.05);
          border-style: solid;
          border-width: 1px;
          border-color: rgba(114, 114, 114, 0.15);
        "
      >
        <h6 class="my-1">
          {{ data.lastModifiedUserId ? this.$store.getters.getUsernameById(data.lastModifiedUserId) : '-' }}
        </h6>
      </b-list-group-item>
    </b-list-group>

    <b-list-group horizontal>
      <b-list-group-item
        class="col-6 d-flex align-items-center"
        style="
          background-color: rgba(114, 114, 114, 0.05);
          border-style: solid;
          border-width: 1px;
          border-color: rgba(114, 114, 114, 0.15);
        "
      >
        <h6 class="m-0 my-1">Bearbeitungsdatum</h6>
      </b-list-group-item>
      <b-list-group-item
        class="col-6 d-flex align-items-center"
        style="
          background-color: rgba(114, 114, 114, 0.05);
          border-style: solid;
          border-width: 1px;
          border-color: rgba(114, 114, 114, 0.15);
        "
      >
        <h6 class="my-1">
          {{ data.bearbeitungsdatum ? this.dateFormatterStandard(data.bearbeitungsdatum) : '-' }}
        </h6>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
<style scoped></style>
<script>
import { format, parseISO } from 'date-fns';
import { mapState } from 'vuex';
import {
  ursachenPossibilities,
  loesungsansatzOptions,
  akzeptanzgrundPossibilities,
  editStatusOptions,
} from '@/core/flugverfuegbarkeit/bearbeitungs-options.config';
import { SET_DATAWASCHANGED } from '@/core/flugverfuegbarkeit/stores/flugverfuegbarkeit.module';
import AppSelect from '@/components/common/app-select/app-select.vue';
export default {
  components: {
    AppSelect,
  },
  data() {
    return {
      labels: [
        'Ursachen',
        'Beschreibung',
        'Verfügbarkeit geschaffen',
        'Lösungsansatz',
        'Akzeptiert',
        'Grund Akzeptanz',
        'Bearbeitende Person',
      ],
      loesungsansatzOptions,
      statusOptions: editStatusOptions,
      formVariables: {
        ursacheSelected: null,
        loesungsansatzSelected: null,
        akzeptanzgrundSelected: null,
        akzeptiertStatus: false,
        beschreibungText: null,
        statusSelected: null,
      },
    };
  },
  watch: {
    data(newData) {
      this.initializeFormVariables();
      this.checkIfDataWasChangedAndCommit();
    },
  },
  computed: {
    ...mapState({
      data: state => state.flugverfuegbarkeit.detailData,
      dataWasChanged: state => state.flugverfuegbarkeit.bearbeitung.dataWasChanged,
    }),
    akzeptanzgrundOptions() {
      if (this.data.status) {
        return akzeptanzgrundPossibilities.find(item => item.status === this.data.status).options;
      } else return [];
    },
    ursachenOptions() {
      if (this.data.status) {
        return ursachenPossibilities.find(item => item.status === this.data.status).options;
      } else return [];
    },
  },
  methods: {
    // Lösungsansatz und Akzeptanzgrund hängen am Status und werden bei dessen Wechsel geleert
    onStatusChange() {
      this.formVariables.akzeptanzgrundSelected = null;
      this.formVariables.loesungsansatzSelected = null;
      this.checkIfDataWasChangedAndCommit();
    },
    // Die Felder halten den Enum-Wert, deshalb werden die gespeicherten Werte direkt übernommen
    initializeFormVariables() {
      this.formVariables.ursacheSelected = this.data.ursache || null;
      this.formVariables.statusSelected = this.data.bearbeitungStatus || null;
      this.formVariables.loesungsansatzSelected = this.data.loesungsansatz || null;
      // Der Akzeptanzgrund gehört zu einem Status, ohne diesen bleibt er leer
      this.formVariables.akzeptanzgrundSelected =
        this.data.akzeptanzgrund && this.data.status ? this.data.akzeptanzgrund : null;
      this.formVariables.beschreibungText = this.data.beschreibung || null;
    },

    checkIfDataWasChangedAndCommit() {
      const statusChanged = this.data?.bearbeitungStatus != this.formVariables.statusSelected;
      const ursacheChanged = this.data?.ursache != this.formVariables.ursacheSelected;
      const beschreibungChanged = this.data.beschreibung != this.formVariables.beschreibungText;
      const akzeptanzgrundChanged = this.data.akzeptanzgrund != this.formVariables.akzeptanzgrundSelected;
      const loesungsansatzChanged = this.data.loesungsansatz != this.formVariables.loesungsansatzSelected;

      const dataChanged =
        statusChanged ||
        ursacheChanged ||
        beschreibungChanged ||
        akzeptanzgrundChanged ||
        loesungsansatzChanged;

      this.$store.commit('flugverfuegbarkeit/' + SET_DATAWASCHANGED, dataChanged);
      this.$emit('data-was-changed', this.formVariables);

      return dataChanged;
    },
    akzeptiertStatusChanged() {
      if (!this.formVariables.akzeptiertStatus) {
        this.formVariables.akzeptanzgrundSelected = null;
      }
      this.checkIfDataWasChangedAndCommit();
    },
    resetBeschreibung() {
      this.formVariables.beschreibungText = null;
      this.checkIfDataWasChangedAndCommit();
    },
    dateFormatterStandard(date) {
      return format(parseISO(date), 'dd.MM.yyyy');
    },
  },
};
</script>
